<div *ngIf="!!editPatientAppUrl" class="patient-app-edit-iframe-wrapper" id="patient-app-edit"> 
	<iframe [src]="editPatientAppUrl" class="patient-app-edit-iframe"></iframe>
</div>

<div *ngIf="!!searchPatientAppUrl" class="patient-app-search-iframe-wrapper" id="patient-app-search">
	<iframe [src]="searchPatientAppUrl" class="patient-app-search-iframe"></iframe>
</div>